export default "__VITE_ASSET__77f7a3cc__"